import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  onClick: () => void;
  cursor?: string;
};

const LoadMoreButton = ({ onClick, cursor }: Props) => {
  const { t } = useTranslation();

  if (!cursor) return null;

  return (
    <Box display="flex" justifyContent="center" m={2}>
      <Button
        onClick={onClick}
        variant="contained"
        sx={{
          minHeight: "42px",
          borderRadius: "20px",
          minWidth: "120px",
        }}
      >
        {t("common:loadMore")}
      </Button>
    </Box>
  );
};

export default LoadMoreButton;
